

<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>





<br>
<br><br>
<!-- Refund Policy Hero Section -->
<section class="privacy-hero">
  <div class="hero-overlay">
    <h1>Refund Policy</h1>
  </div>
</section>

<!-- Refund Policy Content Section -->
<section class="privacy-content container">
  <div class="policy-section">
    
    <p>This Refund and Cancellation Policy (“Policy”) governs the terms under which refunds, cancellations, and billing adjustments are handled for services provided by Baabuji Venturess Pvt Ltd (“Company”, “we”, “our”, “us”) through the Facheck platform (https://facheck.in & https://facheck.biz) (the “Platform”). By using the Platform and its services, you (“Client” or “User”) agree to be bound by this Policy. </p>
<p>The Platform operates on a usage-based billing model, offering both prepaid wallet-based services and postpaid billing arrangements. Under the prepaid model, Clients are required to add funds to their wallet in advance in order to access and use the services. All wallet top-ups made on the Platform are considered final and non-refundable in nature, except in specific circumstances as outlined in this Policy. Any unused balance in the wallet shall remain available for future use and shall not be eligible for withdrawal or cash refund unless explicitly approved by the Company under exceptional conditions.  </p>
<p>Refunds may be considered only in cases where a transaction has failed but the amount has been debited from the Client’s account, or where a duplicate payment has been made due to a technical error. In such cases, the refund shall be processed after verification and confirmation from the payment gateway or banking partner. The timeline for such refunds may vary depending on the policies of the respective payment service provider, but the Company shall make reasonable efforts to ensure that eligible refunds are processed within 5 to 10 business days. </p>
<p>In the case of API usage, all charges incurred are strictly based on successful or attempted API requests made by the Client. Once an API request has been processed, the corresponding charges shall be considered final and non-refundable, irrespective of the outcome of the verification result, as the service involves real-time interaction with third-party systems and infrastructure costs are incurred upon each request. </p>
<p>For Clients operating under a postpaid billing model, invoices are generated based on actual usage and must be settled within the specified payment terms. No refunds shall be issued for billed usage under the postpaid model. Any disputes related to billing or invoicing must be raised in writing within seven (7) days from the date of the invoice, along with relevant supporting details. Failure to raise such disputes within the stipulated timeframe shall be deemed as acceptance of the charges. 

In the event of service cancellation, Clients may choose to discontinue the use of the Platform at any time. However, such discontinuation shall not entitle the Client to any refund of previously paid amounts, including unused wallet balances, unless otherwise determined by the Company at its sole discretion. Any outstanding dues under the postpaid model shall remain payable even after discontinuation of services. </p>
<p>The Company reserves the right to suspend or terminate services in cases of violation of Terms and Conditions, misuse of the Platform, fraudulent activity, or non-payment of dues. In such cases, no refunds shall be provided, and any remaining wallet balance may be forfeited, subject to applicable laws. </p>
<p>All payments on the Platform are processed through RBI-authorized, PCI-DSS compliant payment gateways. In cases where a payment is debited but the transaction status remains unclear or unsuccessful, Clients are advised to contact the Company’s support team with relevant transaction details for prompt resolution. </p>
<p>The Company reserves the right to modify or update this Policy at any time without prior notice. Any changes shall be effective immediately upon publication on the Platform. Continued use of the services shall constitute acceptance of the revised Policy. </p>

 <p>
      For any refund-related queries, disputes, or support requests, Clients may contact:
    </p>
    <ul>
      <li>Email: <a href="mailto:support@facheck.in">support@facheck.in</a></li>
      <li>Company: Baabuji Venturess Pvt Ltd</li>
    </ul>
  </div>

  

  
</section>

 






